<div class="customer-contact-info">

    <div (click)="onPreviousBtnClicked()" class="ps-back">
        <i class="fa fa-chevron-left"></i>
        Zurück
    </div>


    <div class="title">Vielen Dank für Ihre Antworten.</div>
    <div class="description">Ihre Daten werden übermittelt und unserer Concierge oder die zuständige Abteilung wird
        unter den uns vorliegenden Kontaktdaten an Sie herantreten.
    </div>


    <div class="radio-type" (click)="setCustomerContactType(salesConciergeContactType.EXISTING_CONTACT_INFO)"
         [ngClass]="{'bd-radio': true, 'selected': salesConciergeContactType[selectedContactType] === salesConciergeContactType.EXISTING_CONTACT_INFO || salesConciergeContactType[salesConciergeRequest.contactType]=== salesConciergeContactType.EXISTING_CONTACT_INFO || salesConciergeRequest.contactType === null}">
        {{ salesConciergeContactType.EXISTING_CONTACT_INFO }}
    </div>
    <div class="radio-type" (click)="setCustomerContactType(salesConciergeContactType.CUSTOM_CONTACT_INFO)"
         [ngClass]="{'bd-radio': true, 'selected': salesConciergeContactType[selectedContactType] === salesConciergeContactType.CUSTOM_CONTACT_INFO || salesConciergeContactType[salesConciergeRequest.contactType]=== salesConciergeContactType.CUSTOM_CONTACT_INFO}">
        {{ salesConciergeContactType.CUSTOM_CONTACT_INFO }}
    </div>


    <div class="info-elements"
         *ngIf="showCustomerInfo || salesConciergeContactType[salesConciergeRequest.contactType]=== salesConciergeContactType.CUSTOM_CONTACT_INFO">
        <div>
            <bd-labeled-input label="Name*" placeholder="Ihr Name" required

                              (ngModelChange)="setCustomerContactInfoName($event)"
                              name="name" [(ngModel)]="salesConciergeRequest.customContactInfo.name"

            ></bd-labeled-input>
        </div>
        <div>
            <bd-labeled-input label="E-Mail Adresse*" placeholder="Ihre E-Mail Adresse" required email
                              (ngModelChange)="setCustomerContactInfoEmail($event)"
                              name="email" [(ngModel)]="salesConciergeRequest.customContactInfo.email"
            ></bd-labeled-input>
        </div>
        <div>
            <bd-labeled-input label="Telefon" placeholder="Ihre Telefonnummer"
                              (ngModelChange)="setCustomerContactInfoPhone($event)"
                              name="phone" [(ngModel)]="salesConciergeRequest.customContactInfo.phone"
            ></bd-labeled-input>
        </div>
    </div>
    <div class="divider"></div>
    <div class="title">Haben Sie noch eine Anmerkung für uns?</div>

    <div>
        <bd-labeled-textarea label="Ihre Nachricht"
                             placeholder="Max. 500 Zeichen"

                             maxlength="500"
                             (ngModelChange)="setRequestNotes($event)"
                             [(ngModel)]="salesConciergeRequest.requestNotes"
                             rows="3"
                             name="internalComment"
                             limitTo="500">

        </bd-labeled-textarea>
    </div>


</div>
